import React from 'react';

const InternationalChildrenSection = () => {
  return (
    <>
      {/* International transfers */}
      <section id="internasjonalt" style={{ marginBottom: '80px' }}>
        <div
          style={{
            background: 'rgba(10,18,40,0.8)',
            border: '1px solid rgba(59,111,212,0.15)',
            padding: '40px',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(4rem, 10vw, 8rem)',
              fontWeight: 900,
              color: 'rgba(59,111,212,0.06)',
              lineHeight: 1,
              position: 'absolute',
              top: '-10px',
              right: '20px',
              userSelect: 'none',
              letterSpacing: '-0.04em'
            }}
          >
            08
          </div>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#F97316',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}
          >
            § 8 — INTERNASJONALE OVERFØRINGER
          </div>
          <h2
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: 1,
              marginBottom: '20px'
            }}
          >
            Internasjonale dataoverføringer
          </h2>
          <p
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '1rem',
              color: 'rgba(238,240,242,0.7)',
              lineHeight: 1.8,
              marginBottom: '20px',
              maxWidth: '680px'
            }}
          >
            Noen av våre tredjepartstjenester kan overføre data utenfor EØS. I slike tilfeller 
            sikrer vi at overføringen er beskyttet av egnede garantier i henhold til GDPR 
            kapittel V, inkludert:
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '600px' }}>
            {[
              'EU Standard Contractual Clauses (SCC) — Kommisjonsbeslutning 2021/914',
              'Adequacy decisions fra EU-kommisjonen',
              'Binding Corporate Rules (BCR) der aktuelt',
              'EU-US Data Privacy Framework for overføringer til USA'
            ]?.map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: '6px',
                    height: '6px',
                    background: '#3B6FD4',
                    borderRadius: '50%',
                    marginTop: '8px',
                    flexShrink: 0
                  }}
                />
                <span
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.875rem',
                    color: 'rgba(238,240,242,0.65)',
                    lineHeight: 1.6
                  }}
                >
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Children's privacy */}
      <section id="barn" style={{ marginBottom: '80px' }}>
        <div
          style={{
            background: 'linear-gradient(135deg, rgba(139,92,246,0.08) 0%, rgba(59,111,212,0.06) 100%)',
            border: '1px solid rgba(139,92,246,0.2)',
            padding: '40px',
            position: 'relative',
            overflow: 'hidden',
            clipPath: 'polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 20px 100%, 0 calc(100% - 20px))'
          }}
        >
          <div
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(4rem, 10vw, 8rem)',
              fontWeight: 900,
              color: 'rgba(139,92,246,0.06)',
              lineHeight: 1,
              position: 'absolute',
              top: '-10px',
              right: '20px',
              userSelect: 'none',
              letterSpacing: '-0.04em'
            }}
          >
            09
          </div>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#8B5CF6',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}
          >
            § 9 — BARNS PERSONVERN
          </div>
          <h2
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: 1,
              marginBottom: '20px'
            }}
          >
            Barns personvern
          </h2>
          <p
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '1rem',
              color: 'rgba(238,240,242,0.7)',
              lineHeight: 1.8,
              marginBottom: '16px',
              maxWidth: '680px'
            }}
          >
            NordPass sine tjenester er ikke rettet mot barn under 16 år. Vi samler ikke bevisst 
            inn personopplysninger fra barn under 16 år uten verifisert foreldresamtykke i 
            henhold til GDPR artikkel 8 og norsk lov.
          </p>
          <p
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '1rem',
              color: 'rgba(238,240,242,0.7)',
              lineHeight: 1.8,
              maxWidth: '680px'
            }}
          >
            Dersom vi oppdager at vi har samlet inn data fra et barn under 16 år uten gyldig 
            samtykke, vil vi umiddelbart slette disse opplysningene. Foreldre eller foresatte 
            som mener vi har samlet inn data fra deres barn, kan kontakte oss på 
            <span style={{ color: '#8B5CF6' }}> personvern@nordpass.no</span>.
          </p>
        </div>
      </section>
    </>
  );
};

export default InternationalChildrenSection;
